import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";

import { useRootSelector } from "store/hooks";

import classes from "./Footer.module.scss";

export const Footer = () => {
  const { t } = useTranslation(["app"]);
  const { client } = useRootSelector((state) => state.config);

  const { isAuthenticated } = useAuth0();

  const faqClass = [classes.Footer_faq];
  if (isAuthenticated) {
    faqClass.push(classes.Footer_faq_shift);
  }

  const currentYear = new Date().getFullYear();

  return (
    <footer role="contentinfo" className={classes.Footer}>
      <div className={classes.Footer_copyRight}>
        <span className={classes.Footer_copyRight_Label}>
        {t("app:copyright_label", {
            value: currentYear,
          })}
        </span>
      </div>
      {(!!client.primaryContactPhone || !!client.primaryContactEmail) && (
        <div className={classes.Footer_info}>
          {!!client.primaryContactPhone && (
            <span className={classes.Footer_info_phone}>
              <span className={classes.Mobile_phone}>
                <a
                  className={classes.Ancher}
                  href={"tel:" + client.primaryContactPhone}
                >
                  <ft-icon class={classes.Icon}>call</ft-icon>
                </a>
              </span>
              <span className={classes.Web_phone}>
                <ft-icon class={classes.Icon}>call</ft-icon>
                <span>{client.primaryContactPhone}</span>
              </span>
            </span>
          )}
          {!!client.primaryContactEmail && (
            <span className={classes.Footer_info_Email}>
              <span className={classes.Mobile_email}>
                <a
                  className={classes.Ancher}
                  href={"mailto:" + client.primaryContactEmail}
                >
                  <ft-icon class={classes.Icon}>mail_outline</ft-icon>
                </a>
              </span>

              <span className={classes.Web_email}>
                <ft-icon class={classes.Icon}>mail_outline</ft-icon>
                <a
                  className={classes.Ancher}
                  href={"mailto:" + client.primaryContactEmail}
                >
                  {!!client.primaryContactName ? (
                    <span>{client.primaryContactName}</span>
                  ) : (
                    <span>{client.primaryContactEmail}</span>
                  )}
                </a>
              </span>
            </span>
          )}
        </div>
      )}
    </footer>
  );
};
